import MeetupDetailPage from './[id]'

function MeetupDetailWrapper() {
  // The MeetupDetailPage now uses React Router directly, so we don't need to pass params
  return <MeetupDetailPage />
}

export default MeetupDetailWrapper
